import React from 'react';
import { tNotificationsProviderProps } from './Notification.types.ts';
import useNotifications from './Notification.hook.ts';
import NotificationsSidebar from './components/NotificationSideBar/NotificationSideBar.component.tsx';
import { NotificationContext } from './Notifications.constants.ts';

/**
 * AGI-346 — the toast layer used to render EVERY notification, and dismissing
 * a toast to clear the screen POSTed the dismiss, so getting it out of the way
 * destroyed the record. The agenda notifications moved to the Alert Center
 * panel, which reads this same context.
 *
 * NotificationsSidebar stays mounted for one type: the calendar reminder. It
 * is old, heavily used, and 260 workspaces have no bell to receive it, so it
 * keeps its toast AND gets a tray row. Two surfaces, one record, one dismiss.
 */
export const NotificationsProvider = (
  props: tNotificationsProviderProps,
): React.ReactElement => {
  const notifications = useNotifications();

  return (
    <NotificationContext.Provider value={notifications}>
      <NotificationsSidebar>{props.children}</NotificationsSidebar>
    </NotificationContext.Provider>
  );
};
